(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ked-helm-check"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const LEVELS = ['gut', 'pruefen', 'ersetzen'];
    const CHECK_ID = 'helm-check';
    // GA4 parameters. Every push sets all of them, so a value from the previous step never sticks in the dataLayer.
    const GA_KEYS = ['step_number', 'step_name', 'answer', 'check_result', 'check_segment', 'cta', 'product_handle'];

    // Same events for GTM (GA4) and PostHog. Answers only, never the email address.
    function track(eventName, fields, details) {
      const push = { event: eventName, check_id: CHECK_ID };
      GA_KEYS.forEach((key) => {
        push[key] = fields[key];
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(push);
      if (window.KEDPostHogConsentGranted === true && window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, Object.assign({ check_id: CHECK_ID }, fields, details));
      }
    }

    function evaluate(answers, copy) {
      const thisYear = new Date().getFullYear();
      const kid = answers.who === 'kind';
      const damage = answers.damage || [];
      const reasons = [];
      const actions = [];
      let level = 0;
      let due = null;
      let parts = false;
      let fitHelp = false;
      const raise = (value) => {
        if (value > level) level = value;
      };

      if (answers.year === 'unknown') {
        raise(1);
        actions.push(copy.actions.ageUnknown);
      } else if (answers.year) {
        due = parseInt(answers.year, 10) + 5;
        if (thisYear >= due) {
          raise(2);
          reasons.push(copy.reasons.age);
        } else if (due - thisYear <= 1) {
          raise(1);
          actions.push(copy.actions.ageSoon.replace('{year}', due));
        }
      }

      if (answers.crash === 'ride') {
        raise(2);
        reasons.push(copy.reasons.crash);
      } else if (answers.crash === 'drop') {
        raise(1);
        actions.push(copy.actions.drop);
      } else if (answers.crash === 'unknown') {
        raise(1);
        actions.push(copy.actions.crashUnknown);
      }

      if (damage.includes('crack') || damage.includes('shell')) {
        raise(2);
        reasons.push(copy.reasons.damage);
      }
      if (damage.includes('strap')) {
        raise(2);
        reasons.push(copy.reasons.strap);
      }
      if (damage.includes('buckle') || damage.includes('adjust') || damage.includes('pads')) {
        raise(1);
        parts = true;
        actions.push(copy.actions.parts);
      }

      if (answers.fit === 'small') {
        raise(2);
        reasons.push(kid ? copy.reasons.smallKid : copy.reasons.small);
      } else if (answers.fit === 'loose') {
        raise(1);
        fitHelp = true;
        actions.push(copy.actions.loose);
      } else if (answers.fit === 'unknown') {
        raise(1);
        fitHelp = true;
        actions.push(copy.actions.fitUnknown);
      }

      return { level, kid, due, parts, fitHelp, reasons, actions };
    }

    function ctasFor(result, links) {
      if (result.level === 2) {
        return result.kid ? ['kids', 'size'] : ['urban', 'sport', 'ebike'];
      }
      if (result.level === 1) {
        const keys = [];
        if (result.parts) keys.push('parts');
        if (result.fitHelp) keys.push('size');
        if (!keys.length) keys.push(result.kid ? 'kids' : 'all');
        return keys;
      }
      return ['article'];
    }

    function fillList(wrapper, items) {
      const list = wrapper.querySelector('ul');
      list.replaceChildren(
        ...items.map((text) => {
          const item = document.createElement('li');
          item.textContent = text;
          return item;
        })
      );
      wrapper.hidden = items.length === 0;
    }

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const copy = JSON.parse(root.querySelector('[data-check-copy]').textContent);
      const links = JSON.parse(root.querySelector('[data-check-links]').textContent);
      const intro = root.querySelector('[data-intro]');
      const top = root.querySelector('[data-top]');
      const questions = Array.from(root.querySelectorAll('[data-question]'));
      const result = root.querySelector('[data-result]');
      const bar = root.querySelector('[data-progress-bar]');
      const progress = root.querySelector('[role="progressbar"]');
      const label = root.querySelector('[data-progress-label]');
      const form = root.querySelector('form[data-ked-signup]');
      let answers = {};
      let current = -1;

      function show(index) {
        current = index;
        intro.hidden = index !== -1;
        questions.forEach((question, i) => {
          question.hidden = i !== index;
        });
        result.hidden = index !== questions.length;
        top.hidden = index < 0 || index >= questions.length;

        if (index >= 0 && index < questions.length) {
          const percent = Math.round((index / questions.length) * 100);
          bar.style.width = percent + '%';
          progress.setAttribute('aria-valuenow', percent);
          label.textContent = 'Frage ' + (index + 1) + ' von ' + questions.length;
        }
        if (index === questions.length) renderResult();

        const visible = index === -1 ? intro : index === questions.length ? result : questions[index];
        const heading = visible.querySelector('[tabindex="-1"]');
        if (heading && index !== -1) heading.focus({ preventScroll: true });
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }

      function renderResult() {
        const outcome = evaluate(answers, copy);
        result.querySelectorAll('[data-level]').forEach((item) => {
          item.setAttribute('aria-current', String(Number(item.dataset.level) === outcome.level));
        });
        result.querySelector('[data-result-title]').textContent = copy.titles[outcome.level];
        result.querySelector('[data-result-text]').textContent = copy.texts[outcome.level];
        fillList(result.querySelector('[data-result-reasons]'), outcome.reasons);
        fillList(result.querySelector('[data-result-actions]'), outcome.actions);

        const dueBox = result.querySelector('[data-result-due]');
        dueBox.hidden = !(outcome.due && outcome.level < 2);
        dueBox.textContent = dueBox.hidden ? '' : copy.due.replace('{year}', outcome.due);

        const tip = result.querySelector('[data-result-tip]');
        tip.hidden = !(answers.storage === 'car' || answers.storage === 'outside');
        tip.textContent = tip.hidden ? '' : copy.tip;

        const ctaBox = result.querySelector('[data-result-ctas]');
        ctaBox.replaceChildren(
          ...ctasFor(outcome, links)
            .filter((key) => links[key])
            .map((key, i) => {
              const link = document.createElement('a');
              link.className = i === 0 ? 'button' : 'button button--secondary';
              link.href = links[key];
              link.dataset.cta = key;
              link.textContent = copy.ctas[key];
              return link;
            })
        );

        const reminder = outcome.level < 2 && outcome.due;
        result.querySelector('[data-email-title]').textContent = reminder ? copy.email.reminderTitle : copy.email.codeTitle;
        result.querySelector('[data-email-text]').textContent = reminder
          ? [copy.email.reminderText.replace('{year}', outcome.due), outcome.kid ? copy.email.reminderKid : '', copy.email.reminderNew]
              .filter(Boolean)
              .join(' ')
          : copy.email.codeText;
        result.querySelector('[data-email-cta]').textContent = reminder ? copy.email.reminderCta : copy.email.codeCta;

        const properties = {
          helm_check_status: LEVELS[outcome.level],
          helm_fuer: answers.who || '',
          helm_erste_nutzung: answers.year || ''
        };
        if (outcome.due && outcome.level < 2) properties.helm_ersatz_faellig = outcome.due + '-01-01';
        if (outcome.kid) properties.kopf_gemessen_am = new Date().toISOString().slice(0, 10);
        form.dataset.properties = JSON.stringify(properties);

        track(
          'check_completed',
          { check_result: LEVELS[outcome.level], check_segment: answers.who },
          {
            erste_nutzung: answers.year,
            sturz: answers.crash,
            schaeden: (answers.damage || []).join(','),
            sitz: answers.fit,
            lagerung: answers.storage,
            ersatz_faellig: outcome.due,
            empfehlungen: ctasFor(outcome, links).join(','),
            $set: { helm_check_result: LEVELS[outcome.level], helm_check_fuer: answers.who }
          }
        );
      }

      function trackStep(question) {
        const key = question.dataset.question;
        const value = answers[key];
        track('check_step_completed', {
          step_number: questions.indexOf(question) + 1,
          step_name: key,
          answer: Array.isArray(value) ? value.join(',') : value
        });
      }

      root.addEventListener('click', (event) => {
        const option = event.target.closest('[data-value]');
        if (option) {
          const question = option.closest('[data-question]');
          const key = question.dataset.question;
          if (question.hasAttribute('data-multi')) {
            const value = option.dataset.value;
            let selected = answers[key] || [];
            if (value === 'none') {
              selected = selected.includes('none') ? [] : ['none'];
            } else {
              selected = selected.filter((item) => item !== 'none');
              selected = selected.includes(value) ? selected.filter((item) => item !== value) : selected.concat(value);
            }
            answers[key] = selected;
            question.querySelectorAll('[data-value]').forEach((button) => {
              button.setAttribute('aria-pressed', String(selected.includes(button.dataset.value)));
            });
            question.querySelector('[data-next]').disabled = selected.length === 0;
          } else {
            answers[key] = option.dataset.value;
            question.querySelectorAll('[data-value]').forEach((button) => {
              button.setAttribute('aria-pressed', String(button === option));
            });
            trackStep(question);
            setTimeout(() => show(current + 1), 150);
          }
          return;
        }
        const resultLink = event.target.closest('[data-result] a[href]');
        if (resultLink && !resultLink.closest('form')) {
          track('check_result_click', { cta: resultLink.dataset.cta || 'link' }, { link_url: resultLink.pathname });
        }
        if (event.target.closest('[data-start]')) {
          track('check_started', {});
          show(0);
        }
        if (event.target.closest('[data-next]')) {
          trackStep(questions[current]);
          show(current + 1);
        }
        if (event.target.closest('[data-back]')) show(Math.max(-1, current - 1));
        if (event.target.closest('[data-restart]')) {
          answers = {};
          root.querySelectorAll('[aria-pressed]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
          root.querySelector('[data-next]').disabled = true;
          show(-1);
          intro.querySelector('[data-start]').focus();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-ked-helm-check]').forEach(init);
    }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ked-kinderhelm-check"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SIZE_PATTERN = /(\d+)\s*-\s*(\d+)\s*\(([^)]+)\)/;
    const CHECK_ID = 'kinderhelm-check';
    // GA4 parameters. Every push sets all of them, so a value from the previous step never sticks in the dataLayer.
    const GA_KEYS = ['step_number', 'step_name', 'answer', 'check_result', 'check_segment', 'cta', 'product_handle'];

    // Same events for GTM (GA4) and PostHog. Answers only, never the email address.
    function track(eventName, fields, details) {
      const push = { event: eventName, check_id: CHECK_ID };
      GA_KEYS.forEach((key) => {
        push[key] = fields[key];
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(push);
      if (window.KEDPostHogConsentGranted === true && window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, Object.assign({ check_id: CHECK_ID }, fields, details));
      }
    }

    function parseHelmets(raw) {
      return raw.map((helmet) => {
        const sizes = helmet.sizes
          .map((size) => {
            const match = size.value.match(SIZE_PATTERN);
            if (!match) return null;
            return { label: match[3].trim(), lo: Number(match[1]), hi: Number(match[2]), variant: size.variant };
          })
          .filter(Boolean)
          .sort((a, b) => a.lo - b.lo);
        return Object.assign({}, helmet, { sizes, facts: helmet.facts.filter(Boolean) });
      });
    }

    // The size whose range centre is nearest wins; a tie goes to the larger size.
    function pickSize(helmet, cm) {
      const fits = helmet.sizes.filter((size) => cm >= size.lo && cm <= size.hi);
      if (!fits.length) return null;
      let best = fits[0];
      let bestDistance = Math.abs(cm - (best.lo + best.hi) / 2);
      fits.slice(1).forEach((size) => {
        const distance = Math.abs(cm - (size.lo + size.hi) / 2);
        if (distance < bestDistance - 0.01 || (Math.abs(distance - bestDistance) <= 0.01 && size.lo > best.lo)) {
          best = size;
          bestDistance = distance;
        }
      });
      return Object.assign({}, best, { overlap: fits.length > 1 });
    }

    function recommend(helmets, answers) {
      const young = ['u1', '1-2', '3-5'].includes(answers.age);
      let pool = helmets.map((helmet) => ({ helmet, size: answers.measured ? pickSize(helmet, answers.cm) : null }));
      if (answers.measured) pool = pool.filter((entry) => entry.size);

      let list = pool.filter((entry) => entry.helmet.uses.includes(answers.use));
      let fallback = false;
      let bigHead = false;
      if (!list.length && pool.length) {
        list = pool.filter((entry) => entry.helmet.uses.includes('school') || entry.helmet.uses.includes('first'));
        fallback = true;
      }
      // Only a few large sizes left: show whatever fits and point to adult helmets too.
      if (!list.length && pool.length) {
        list = pool.slice();
        bigHead = true;
      }

      list.forEach((entry) => {
        const ageFit = (young && entry.helmet.group === 'little') || (!young && entry.helmet.group === 'young') ? 1 : 0;
        const soldOut = entry.size && !entry.size.variant ? 5 : 0;
        entry.score = (entry.helmet.points[answers.prio] || 0) * 2 + ageFit - soldOut;
      });
      list.sort((a, b) => b.score - a.score);
      return { list: list.slice(0, 3), fallback: fallback && !bigHead, bigHead, empty: !pool.length };
    }

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const copy = JSON.parse(root.querySelector('[data-check-copy]').textContent);
      const helmets = parseHelmets(JSON.parse(root.querySelector('[data-check-helmets]').textContent));
      const intro = root.querySelector('[data-intro]');
      const top = root.querySelector('[data-top]');
      const questions = Array.from(root.querySelectorAll('[data-question]'));
      const result = root.querySelector('[data-result]');
      const bar = root.querySelector('[data-progress-bar]');
      const progress = root.querySelector('[role="progressbar"]');
      const label = root.querySelector('[data-progress-label]');
      const range = root.querySelector('[data-cm-input]');
      const form = root.querySelector('form[data-ked-signup]');
      let answers = { cm: Number(range.value) };
      let current = -1;

      function show(index) {
        current = index;
        intro.hidden = index !== -1;
        questions.forEach((question, i) => {
          question.hidden = i !== index;
        });
        result.hidden = index !== questions.length;
        top.hidden = index < 0 || index >= questions.length;

        if (index >= 0 && index < questions.length) {
          const percent = Math.round((index / questions.length) * 100);
          bar.style.width = percent + '%';
          progress.setAttribute('aria-valuenow', percent);
          label.textContent = 'Frage ' + (index + 1) + ' von ' + questions.length;
        }
        if (index === questions.length) renderResult();

        const visible = index === -1 ? intro : index === questions.length ? result : questions[index];
        const heading = visible.querySelector('[tabindex="-1"]');
        if (heading && index !== -1) heading.focus({ preventScroll: true });
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }

      function card(entry) {
        const helmet = entry.helmet;
        const article = document.createElement('article');
        article.className = 'ked-check__product';

        const media = document.createElement('div');
        media.className = 'ked-check__product-media';
        if (helmet.image) {
          const image = document.createElement('img');
          image.src = helmet.image;
          image.alt = helmet.title;
          image.loading = 'lazy';
          image.width = 480;
          image.height = 480;
          media.appendChild(image);
        }

        const body = document.createElement('div');
        body.className = 'ked-check__product-body';
        const title = document.createElement('h3');
        title.className = 'h5';
        title.textContent = helmet.title;
        const size = document.createElement('p');
        size.className = 'ked-check__size';
        size.textContent = entry.size
          ? copy.size.replace('{label}', entry.size.label).replace('{lo}', entry.size.lo).replace('{hi}', entry.size.hi)
          : copy.sizesAll
              .replace('{lo}', helmet.sizes[0].lo)
              .replace('{hi}', Math.max.apply(null, helmet.sizes.map((s) => s.hi)));
        const price = document.createElement('p');
        price.className = 'ked-check__price';
        price.textContent = (helmet.priceVaries ? copy.from + ' ' : '') + helmet.price;
        const facts = document.createElement('ul');
        facts.className = 'ked-check__list';
        helmet.facts.forEach((fact) => {
          const item = document.createElement('li');
          item.textContent = fact;
          facts.appendChild(item);
        });
        body.append(title, size, price, facts);

        if (entry.size && !entry.size.variant) {
          const soldOut = document.createElement('p');
          soldOut.className = 'ked-check__note';
          soldOut.textContent = copy.soldOut;
          body.appendChild(soldOut);
        }

        const link = document.createElement('a');
        link.className = 'button';
        link.href = entry.size && entry.size.variant ? helmet.url + '?variant=' + entry.size.variant : helmet.url;
        link.dataset.cta = 'product';
        link.dataset.productHandle = helmet.handle;
        link.textContent = copy.view;
        body.appendChild(link);

        article.append(media, body);
        return article;
      }

      function renderResult() {
        const rec = recommend(helmets, answers);
        const notes = [];
        let title = answers.measured ? copy.titleMeasured.replace('{cm}', answers.cm) : copy.titleOpen;
        let text = answers.measured ? copy.textMeasured : copy.textOpen;
        const smallest = Math.min.apply(null, helmets.flatMap((helmet) => helmet.sizes.map((size) => size.lo)));

        result.querySelector('[data-result-adult]').hidden = true;
        if (rec.empty && answers.cm < smallest) {
          title = copy.tooSmallTitle;
          text = copy.tooSmallText.replace('{cm}', smallest);
        } else if (rec.empty) {
          title = copy.tooBigTitle;
          text = copy.tooBigText.replace('{cm}', answers.cm);
          result.querySelector('[data-result-adult]').hidden = false;
        } else if (rec.bigHead) {
          notes.push(copy.notes.bigHead);
          result.querySelector('[data-result-adult]').hidden = false;
        }

        if (rec.fallback && answers.use === 'trail') notes.push(copy.notes.trail);
        if (rec.fallback && answers.use === 'skate') notes.push(copy.notes.skate);
        if (rec.fallback && answers.use === 'seat') notes.push(copy.notes.seatFallback);
        if (answers.use === 'seat') notes.push(copy.notes.seat);
        if (answers.age === 'u1') notes.push(copy.notes.baby);
        if (rec.list.some((entry) => entry.size && entry.size.overlap)) notes.push(copy.notes.overlap);
        if (!answers.measured) notes.push(copy.notes.measure);
        if (rec.list.length) notes.push(copy.notes.fit);

        result.querySelector('[data-result-title]').textContent = title;
        result.querySelector('[data-result-text]').textContent = text;
        result.querySelector('[data-result-cards]').replaceChildren(...rec.list.map(card));

        const notesBox = result.querySelector('[data-result-notes]');
        notesBox.querySelector('ul').replaceChildren(
          ...notes.map((note) => {
            const item = document.createElement('li');
            item.textContent = note;
            return item;
          })
        );
        notesBox.hidden = notes.length === 0;

        const properties = {
          kind_alter: answers.age,
          kind_einsatz: answers.use,
          kind_prioritaet: answers.prio,
          kinderhelm_empfehlung: rec.list.map((entry) => entry.helmet.handle).join(', ')
        };
        if (answers.measured) {
          properties.kind_kopfumfang_cm = answers.cm;
          properties.kopf_gemessen_am = new Date().toISOString().slice(0, 10);
        }
        form.dataset.properties = JSON.stringify(properties);

        // The result is the top pick, or why there is none.
        let outcome = rec.list.length ? rec.list[0].helmet.handle : 'keine_empfehlung';
        if (rec.empty) outcome = answers.cm < smallest ? 'kopf_zu_klein' : 'kopf_zu_gross';
        track(
          'check_completed',
          { check_result: outcome, check_segment: answers.age },
          {
            einsatz: answers.use,
            prioritaet: answers.prio,
            gemessen: !!answers.measured,
            kopfumfang_cm: answers.measured ? answers.cm : undefined,
            empfehlungen: properties.kinderhelm_empfehlung,
            anzahl_empfehlungen: rec.list.length,
            $set: { kinderhelm_empfehlung: properties.kinderhelm_empfehlung, kinderhelm_alter: answers.age }
          }
        );
      }

      function trackStep(question, answer) {
        track('check_step_completed', {
          step_number: questions.indexOf(question) + 1,
          step_name: question.dataset.question,
          answer: String(answer)
        });
      }

      range.addEventListener('input', () => {
        answers.cm = Number(range.value);
        root.querySelectorAll('[data-cm-output]').forEach((output) => {
          output.textContent = range.value;
        });
      });

      root.addEventListener('click', (event) => {
        const option = event.target.closest('[data-value]');
        if (option) {
          const question = option.closest('[data-question]');
          answers[question.dataset.question] = option.dataset.value;
          question.querySelectorAll('[data-value]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === option));
          });
          trackStep(question, option.dataset.value);
          setTimeout(() => show(current + 1), 150);
          return;
        }
        const resultLink = event.target.closest('[data-result] a[href]');
        if (resultLink && !resultLink.closest('form')) {
          const cta = resultLink.dataset.cta || (resultLink.closest('[data-result-adult]') ? 'adult' : 'link');
          track('check_result_click', { cta, product_handle: resultLink.dataset.productHandle }, { link_url: resultLink.pathname });
        }
        if (event.target.closest('[data-start]')) {
          track('check_started', {});
          show(0);
        }
        if (event.target.closest('[data-back]')) show(Math.max(-1, current - 1));
        if (event.target.closest('[data-use-cm]')) {
          answers.measured = true;
          trackStep(questions[current], answers.cm);
          show(current + 1);
        }
        if (event.target.closest('[data-skip-cm]')) {
          answers.measured = false;
          trackStep(questions[current], 'nicht_gemessen');
          show(current + 1);
        }
        if (event.target.closest('[data-restart]')) {
          answers = { cm: Number(range.value) };
          root.querySelectorAll('[aria-pressed]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
          show(-1);
          intro.querySelector('[data-start]').focus();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-ked-kinderhelm-check]').forEach(init);
    }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
